import { Icon, IconButton } from '@atom/mui';
import colors from '@atom/styles/colors';

import classes from './workSummaryTray.module.css';

interface Props {
  isCompleted: boolean;
}

const TaskCompletionIcon = ({ isCompleted }: Props) => {
  return (
    <div className={classes.taskCompletionIcon}>
      <IconButton>
        <Icon color={isCompleted ? colors.brand.green : colors.neutral.silver}>
          {isCompleted ? 'check_circle' : 'check_circle_outline'}
        </Icon>
      </IconButton>
    </div>
  );
};

export default TaskCompletionIcon;
